'use client';

import { useTranslation } from 'react-i18next';
import { Icon } from '../icons';
import { normalizeMatchLocale } from '../../i18n/matchLocale';
import { FilterSelect } from './filter-select';
import { cn } from '../../lib/utils';

export type LanguageSelectorProps = {
  className?: string;
};

export function LanguageSelector({ className }: LanguageSelectorProps) {
  const { t, i18n } = useTranslation('matching');
  const locale = normalizeMatchLocale(i18n.resolvedLanguage ?? i18n.language);

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Icon
        name='globe-cursor-outline'
        className='size-4 shrink-0 text-muted-foreground'
        aria-hidden
      />
      <FilterSelect
        value={locale}
        label={t('language.label')}
        aria-label={t('language.label')}
        options={[
          { id: 'en', label: t('language.english') },
          { id: 'es', label: t('language.spanish') },
        ]}
        onChange={(next) =>
          void i18n.changeLanguage(normalizeMatchLocale(next))
        }
        className='min-w-0 [&_select]:min-w-26'
      />
    </div>
  );
}
